import { compose } from "redux";
import { Field } from "redux-form/immutable";
import React, { PureComponent } from "react";

import { required } from "utils/validation.util";
import TextField from "app/components/form/TextField";
import { COURSE_TYPE_FORM } from "features/competence.constants";

class CourseTypeForm extends PureComponent {
  render() {
    const { handleSubmit } = this.props;

    return (
      <form id={COURSE_TYPE_FORM.ID} onSubmit={handleSubmit}>
        <Field
          autoFocus
          required
          label="Name"
          validate={[required]}
          component={TextField}
          name={COURSE_TYPE_FORM.NAME}
        />
      </form>
    );
  }
}

export default compose()(CourseTypeForm);
